var _g, _path, _circle, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgRedMapMarker = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 43,
    viewBox: "0 0 50 43",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.56,
    filter: "url(#filter0_f_2990_1859)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M46 39H14L29.4286 12L45.4286 18.8936L46 39Z",
    fill: "url(#paint0_linear_2990_1859)"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.1111 15.5556C31.1111 25.8329 21.9743 34.715 17.7055 38.3039C16.4384 39.3692 14.6538 39.3955 13.3644 38.3573C9.07835 34.9068 0 26.3269 0 15.5556C0 6.96446 6.96446 0 15.5556 0C24.1467 0 31.1111 6.96446 31.1111 15.5556Z",
    fill: "#EC3342"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 15.8631,
    cy: 14.4842,
    r: 6.2069,
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_2990_1859",
    x: 10,
    y: 8,
    width: 40,
    height: 35,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2,
    result: "effect1_foregroundBlur_2990_1859"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2990_1859",
    x1: 16.5263,
    y1: 37.3125,
    x2: 35.7051,
    y2: 30.2483,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#060B17"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#060B17",
    stopOpacity: 0
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgRedMapMarker);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/red-map-marker.d92a9266771a89a0cb55428b8639b094.svg";